/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  dataGrid: Item<'DataGrid'>;
  idNumberColumn: Item<'NumberColumn'>;
  buttonColumn: Item<'ButtonColumn'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionShowMessage: Item<'ActionShowMessage'>;
} = {
  root: {
    children: ['testAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: { all: 0 },
      windowTitle: { type: 'text', value: 'Button Column Example' },
    },
    type: 'Page',
  },

  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },

  flexItem: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },

  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: `[
  { "id": 1, "status": "Approved" },
  { "id": 2, "status": "Pending" },
  { "id": 3, "status": "Rejected" },
  { "id": 4, "status": "Pending" },
  { "id": 5, "status": "Approved" }
]`,
    },
    type: 'LocalDataStore',
  },

  testAliasDataStoreReference: {
    children: ['dataGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem',
    props: { alias: 'testAlias' },
    type: 'DataStoreReference',
  },

  dataGrid: {
    children: ['idNumberColumn', 'buttonColumn'],
    itemId: 'dataGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      expandLastColumn: false,
      showBorder: true,
      updatable: { type: 'boolean', value: false },
      insertable: { type: 'boolean', value: false },
    },
    type: 'DataGrid',
  },

  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'dataGrid',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
      width: 60,
    },
    type: 'NumberColumn',
  },

  buttonColumn: {
    children: ['triggerOnClick'],
    itemId: 'buttonColumn',
    parent: 'dataGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Action' },
      text: { type: 'expression', value: "'Click Me'" },
      color: 'primary',
      variant: 'contained',
      startIcon: { iconName: 'arrow-pointer', iconType: 'light' },
      endIcon: { iconName: '', iconType: 'light' },
      iconColor: { type: 'expression', value: "'inherit'" },
      size: 'medium',
      disableCondition: '',
      fullWidth: false,
      disableElevation: false,
      showOnlyOnHover: false,
      hotKey: '',
      toolTip: { type: 'text', value: 'Click to trigger action' },
      toolTipPlacement: 'top',
      onClickFunction: { type: 'text', value: '' },
      viewAttribute: '',
      width: 200,
    } as any,
    type: 'ButtonColumn',
  },

  triggerOnClick: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick',
    parent: 'buttonColumn',
    props: {},
    type: 'TriggerOnClick',
  },

  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick',
    props: {
      message: { type: 'text', value: 'button clicked' },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
};

export const helpRenders: ComponentSample<'ButtonColumn'>[] = [
  {
    title: 'Full-Feature Button Column Example',
    page,
    exampleId: 'eg-01GK8QWM9KTAE6TN0ME1F8WQBTN',
    clearParentChildren: false,
    height: 420,
    visibleProps: [
      'label',
      'alignment',
      'width',
      'text',
      'color',
      'variant',
      'size',
      'fullWidth',
      'disableElevation',
      'iconColor',
      'startIcon',
      'endIcon',
      'disableCondition',
      'showOnlyOnHover',
      'hotKey',
      'onClickFunction',
      'toolTip',
      'visible',
      'sortable',
      'filterable',
    ],
    item: {
      children: ['triggerOnClick'],
      itemId: 'buttonColumn',
      parent: 'dataGrid',
      type: 'ButtonColumn',
      props: {
        alignment: 'center',
        label: { type: 'text', value: 'Action' },
        text: { type: 'expression', value: "'Click Me'" },
        color: 'primary',
        variant: 'contained',
        startIcon: { iconName: 'arrow-pointer', iconType: 'light' },
        endIcon: { iconName: '', iconType: 'light' },
        iconColor: { type: 'expression', value: "'inherit'" },
        size: 'medium',
        disableCondition: '',
        fullWidth: false,
        disableElevation: false,
        showOnlyOnHover: false,
        hotKey: '',
        toolTip: { type: 'text', value: 'Click to trigger action' },
        viewAttribute: '',
        width: 200,
      },
    },
  },
];
